
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands, getUuid } from "@common/src/utils/common";
import FileUpload from "@/components/scope/file-upload.vue";
import DelegatePrint from "@/views/service/components/delegate-print.vue";
import SettlementPrint from "@/views/service/components/settlement-print.vue";

import { taxRateRulesEl, isPositiveIntegerZero } from "@common/src/utils/verify";
const base = namespace("base");
const service = namespace("service");
const setting = namespace("setting");
const store = namespace("store");
const finance = namespace("finance");
const app = namespace("app");
@Component({
  components: { SwitchStatus, FileUpload, DelegatePrint, SettlementPrint }
})
@Table("loadListData")
export default class CustomerEditxxx extends Vue {
  @base.Action getDictionaryList;
  @service.Action getPrintStoreLogo;
  @setting.Action reorderingPrintTemplates;
  @setting.Action updatePrintTemplateStatusMy;
  @setting.Action getPatternPaymentList;
  @setting.Action savePrintFieldSet;
  @store.State storeData;
  @finance.Action getReceiptDetail;
  @app.State btnLoading;
  @setting.Action queryPrintTemplatesMy;
  @setting.Action setPrintTemplateStoreLogo;
  @setting.Action myTemplatePreview;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  t = t;
  keyword: string = "";
  serviceList: any[] = [];
  cardTemplateList: any[] = [];
  checked: boolean = false;
  showLogoEdit: boolean = false;
  missPointFlag: boolean = false;
  showPreviewPrint: boolean = false;
  showDelegatePrint: boolean = false;
  showFieldSetting: boolean = false;
  // printLogo: string = "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png";
  orderDataFake = {};
  shanghaiPrint = {};
  detailDataFake = {};
  detailDataPrint: any = {
    orderStatus: "9",
    photoList: [],
    allOrderDetail: { service: [], parts: [], additional: [], receiptData: {} }
  };
  detailData: any = {
    orderStatus: "9",
    photoList: [],
    action: { otherArray: [], mustDoArray: [], optionalArray: [], printArray: [] }
  };
  logoForm = {
    logoSelect: true,
    logoImage: "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png"
  };
  logoFormRule = {
    logoSelect: [{ required: true, validator: this.logoRule, trigger: "blur" }]
  };
  defaultTemplate: any[] = [];
  //计算属性
  get breadData() {
    return [];
  }
  oeFieldCode = "e_o_e_item";
  logoImgRule(value, callback) {
    if (this.logoForm.logoImage) {
      callback();
    } else {
      callback(new Error(t("v270.please-upload-the-logo")));
    }
  }
  logoRule(rule, value, callback) {
    console.log("[ 1231233 ]", 1231233);
    if (value === false) {
      this.logoImgRule(value, callback);
    } else {
      callback();
    }
  }
  created() {
    this.init();
  }
  printFieldList: any = [];
  printContentList: any = [];
  mounted() {}
  async init() {
    this.loadListData();
  }
  getLogoImg() {
    this.getPrintStoreLogo().then(res => {
      this.logoForm.logoSelect = res.data.isDefaultLogo;
      this.logoForm.logoImage = res.data.storeLogo;
      if (!res.data.isDefaultLogo) {
        this.defaultTemplate = [
          {
            url: res.data.storeLogo
          }
        ];
      }
    });
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow?) {
    if (status === 0 && this.cardTemplateList.filter(item => item.status === "1").length === 1) {
      return this.$message.error(t("v270.keep-at-least-one-template"));
    }
    return this.updatePrintTemplateStatusMy({
      status: status,
      printTemplateCode: selectedRow.printTemplateCode
    })
      .then(() => {
        this.$message.success(
          status === 1 ? (t("setting.enable-successful") as string) : (t("setting.disable-success") as string)
        );
        this.checked = false;
        this.loadListData();
      })
      .catch(e => {
        if (e.code === "speedbiz.system.pay-method-least-one-valid") {
          this.$message.error(t("setting.valid-method-payment"));
        }
      });
  }
  handleSearch() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryPrintTemplatesMy({
      printTemplateName: this.keyword || "",
      printTemplateCode: ""
    }).then(data => {
      this.cardTemplateList = data.data;
      return data;
    });
  }
  receiveServicePhone: string = "";
  receiveFieldList: any = null;
  handleView(row) {
    this.myTemplatePreview({
      printTemplateCode: row.printTemplateCode
    }).then(data => {
      window.open(data.data);
    });
  }
  activeRow: any = {};
  printContentFormData = {
    tax: ""
  };
  oeItemList: any = [];
  handleShowFieldSetting(row) {
    this.printContentList = [];
    this.oeItemList = [];
    this.printContentFormData = {
      tax: ""
    };
    this.activeRow = row;
    this.showFieldSetting = true;
    this.printFieldList = row.printFieldList;
    row.printContentList.forEach(item => {
      if (item.fieldCode !== this.oeFieldCode) {
        console.log(111, item);
        this.printContentList.push(item);
        this.$set(this.printContentFormData, item.fieldCode, item.value || "");
        console.log(3333, this.printContentFormData);
      } else {
        this.oeLabel = item.fieldName;
        this.oeItemList = item.listValue.map(value => {
          return {
            fieldType: "2",
            fieldCode: getUuid(6),
            fieldName: this.oeLabel,
            value: value
          };
        });
      }
    });
  }

  selectAll() {
    let ref = this.$refs["table"] as any;
    ref.toggleAllSelection();
  }
  submitForm() {
    (this.$refs["logoForm"] as any).validate(valid => {
      if (valid) {
        this.setPrintTemplateStoreLogo({
          storeLogo: this.logoForm.logoImage,
          isDefaultLogo: this.logoForm.logoSelect
        }).then(res => {
          if (res.code === "0") {
            this.$message.success(t("v270.after-saving-successfully-you-can-click-the-template"));
            this.showLogoEdit = false;
          }
        });
      }
    });
  }
  showLogoEditFn() {
    this.showLogoEdit = true;
    this.getLogoImg();
  }
  changeRadio() {
    (this.$refs.logoForm as any).clearValidate();
  }
  handleSaveFieldSetting() {
    this.handleSavePrintFieldSet();
  }

  handleSavePrintFieldSet() {
    (this.$refs["settingForm"] as any).validate(valid => {
      if (valid) {
        const printContentList = this.printContentList.slice();
        const oeTextArr = this.oeItemList.map(item => item.value);
        printContentList.push({
          fieldCode: this.oeFieldCode,
          fieldType: "2",
          listValue: oeTextArr
        });
        printContentList.forEach(item => {
          if (item.fieldType === "1") {
            item.value = this.printContentFormData[item.fieldCode];
          }
        });
        this.savePrintFieldSet({
          printTemplateCode: this.activeRow.printTemplateCode,
          printFieldList: this.printFieldList,
          printContentList: printContentList
        }).then(() => {
          this.$message.success(t("v210831.saved-successfully"));
          this.init();
          this.showFieldSetting = false;
        });
      }
    });
  }
  requireRule: any = [{ required: true, message: t("v270.this-field-cannot-be-empty") }];
  taxValidator: any = [
    {
      validator: (rule, value, callback) => {
        taxRateRulesEl(value, callback, true);
      }
    }
  ];
  dueDateValidator: any = [
    {
      validator: (rule, value, callback) => {
        if (!isPositiveIntegerZero(value) || value > 1000) {
          callback(new Error(t("th-settlement.expire-date-rule-text")));
        } else {
          callback();
        }
      }
    }
  ];
  oeLabel: string = "";
  handleAddOeItem() {
    if (this.oeItemList.length >= 3) {
      return this.$message.error(t("v270.add-up-to-3"));
    }
    this.oeItemList.push({
      fieldType: "2",
      fieldCode: getUuid(6),
      fieldName: this.oeLabel,
      value: ""
    });
  }
  handleDeleteOeItem(index) {
    this.oeItemList.splice(index, 1);
  }
}
